export default {
    AccountManagementAdd: {
        titile: '基础信息',
        place: '2-20中文/英文/数字',
        name: '名称',
        internationalTelCode: '国际冠号',
        phone: '手机号码',
        account: '账户',
        Nickname: '账户昵称',
        password: '密码',
        email: '邮箱',
        sex: '性别',
        address: '地区',
        Detailed: '详细地址',
        Date: '出生日期',
        ValidPS: '有效日期始不可晚于有效日期末',
        from: '有效期始',
        until: '有效期末',
        Freeze: '冻结',
        Role: '角色',
        Add: '添加角色',
        RoleName: '角色名称',
        TenantName: '所属租户',
        Structure: '组织架构',
        ps: '请输入角色名称',
        ps1: '请输入名称',
        ps2: '请选择有效期',
        ps3: '请为此账户添加一个角色',
        ps4: '编辑账户',
        ps5: '是否要删除',
        ps6: '角色 ?',
        ps7: '提示',
        ps8: '日志',
        tips: "多个电子邮件地址请使用 '；' 分开",
        deptAbbr: '部门简称',
        status: '目前状态',
        onTime: '临存开始时间',
        offTime: '临存结束时间',

      customerInfo: {
          industry: '行业类型',
          title: '客户信息',
          clientCode: '客户编号',
          clientFullName: '客户姓名',
          contactPerson: '客户联系人',
          companyName: '公司中文名称',
          companyEnName: '公司英文名称',
          isNom: '是否月结',
          paymentTerm: '账单到期天数',
          ifLocal: '是否本地客户',
          currencySymbol: '货币符号',
          bpCode: '客户BPCode',
          billingAddress1: '客户账单地址1',
          billingAddress2: '客户账单地址2',
          billingAddressUnit: '客户账单地址公寓号',
          billingAddressCity: '客户账单地址城市',
          billingAddressState: '客户账单地址州',
          billingAddressCountry: '客户账单地址国家',
          billingAddressPostcode: '客户账单地址邮编',
          billingAddressPhone: '客户账单地址电话',
          billingAddressEmail: '客户账单地址邮箱',

          titile: '账户基础信息',
          titile2: '客户基础信息',
          CSGSales: 'CSG 销售',
          CSGCustomerService: 'CSG客服',
          CustomerType: '客户类型',
          ContactPerson: '联系人',
          ContactPhoneNumber: '联系人电话',
          CompanyInformation: '客户公司信息',
          CompanyName: '公司名字',
          GeneralEmail: '通用邮箱',
          generalEmailOther: '其他通用邮箱',
          BillEmail: '账单邮箱',
          BillEmailOther: '其他账单邮箱',
          FinancialEmail: '财务邮箱',
          CustomerServiceEmail: '客服邮箱',
          CustomerServiceEmailOther: '其他客服邮箱',
          CompanyAddress: '公司地址',
          billingInformation: '客户账单信息',
          AccountingPeriod: '账期',
          CreditLimit: '信用额度',
          billingAddress: '账单地址',
          abn: '澳大利亚商务号码',
          weburl: '公司网站',
          MonthlySettlementTime: '月结时间',
          userTip: '账号或密码错误，请再试一次或联系支持人员。',
          palletAccount: '托盘账户',
          deposit: '押金'
        }
    }
};
